module.exports = __webpack_public_path__ + "img/home.a49ccd2a.svg";